import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IApplicationEventInput } from '@ebb-v2/ebb-integration';

@Injectable({
  providedIn: 'root'
})
export abstract class ApplicationEventApiService {



  abstract updateApplicationEvent(applicationEvent: IApplicationEventInput): Observable<any>;
}